import { render, staticRenderFns } from "./BenefactorsRequiredDocuments.vue?vue&type=template&id=3ee409da&scoped=true"
import script from "./BenefactorsRequiredDocuments.vue?vue&type=script&lang=ts"
export * from "./BenefactorsRequiredDocuments.vue?vue&type=script&lang=ts"
import style0 from "./BenefactorsRequiredDocuments.vue?vue&type=style&index=0&id=3ee409da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee409da",
  null
  
)

export default component.exports